/**
 * @ngdoc Factory
 * @name Util
 * @description A factory full of useful helpers.
 * @returns {Object}
 * @constructor
 */
export default function Util() {
  'ngInject';
  /**
   * @name Throttle
   * @description Allow a function being called continuously to only actually run every X ms, taken from http://www.es6fiddle.net/i8d8e1um/ We dont use angulars $timeout because we don't need a digest cycle for this.
   * @param cb function to call
   * @param timeout Number of ms to wait
   * @param context
   * @return {function} The wrapper function
   */
  function throttle(cb, timeout) {
    let waitSet;
    let wait = false;
    return function () {
      let later = () => {
        cb(arguments);
      };
      if (!wait) {
        later(arguments);
        wait = true;
        waitSet = window.setTimeout(() => {
          wait = false;
        }, timeout);
      }
    };
  }

  /**
   * @name Debounce
   * @description Execute function X ms after it has been called continuously. Calling the function three times, each call being less that X ms apart will delay the function execution so the function will only execute once.
   * @param cb function to call
   * @param timeout time to wait in ms
   * @return {function} The wrapper function
   */
  function debounce(cb, timeout) {
    let timeoutId;
    return function (...args) {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        return cb(...args);
      }, timeout);
    };
  }

  function scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  return {
    throttle,
    debounce,
    scrollToTop
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/services/util/util.factory.js
 **/